/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { GoodsCard } from "ui/GoodsCard";
import { StatusLabel } from "ui/StatusLabel";

import { CardLink } from "../CardLink";
import { SearchResultListCount } from "../SearchResultListCount";
import { SearchResultListWrapper } from "../SearchResultListWrapper";
import { ShowMoreButton } from "../ShowMoreButton";
import { isStatusVisible } from "./functions/isHiddenStatus";
import { ulStyle } from "./styles";
import { useThis } from "./useThis";

import type { GoodsSearchResultItem } from "../../types/goodsSearchResultItem";
import type { MouseEventHandler } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  goodsList: GoodsSearchResultItem[];
  isMoreLoading: boolean;
  onClickShowMore: MouseEventHandler<HTMLButtonElement>;
  totalCount: number;
};

export const GoodsSearchResultList: FcWithoutChildren<Props> = (props) => {
  const { goodsList, isMoreLoading, onClickShowMore, totalCount } = props;
  const { ulAriaLabel } = useThis();

  return (
    <SearchResultListWrapper>
      <SearchResultListCount count={totalCount} />

      <ul aria-label={ulAriaLabel} css={ulStyle}>
        {goodsList.map((goods) => {
          const { defaultImage, goodsUrl, id, name, price, seller, status } =
            goods;

          return (
            <li key={id}>
              <CardLink href={goodsUrl}>
                <GoodsCard
                  amount={price}
                  imagePath={defaultImage}
                  labelComponent={
                    isStatusVisible(status) ? (
                      <StatusLabel status={status} />
                    ) : null
                  }
                  shopName={seller}
                  title={name}
                />
              </CardLink>
            </li>
          );
        })}
      </ul>

      <ShowMoreButton
        isLoading={isMoreLoading}
        isShown={goodsList.length < totalCount}
        onClickShowMore={onClickShowMore}
      />
    </SearchResultListWrapper>
  );
};
